export const Provinces = [
  'Eastern Cape',
  'Free State',
  'Gauteng',
  'Kwazulu Natal',
  'Limpopo',
  'Mpumalanga',
  'Northern Cape',
  'North-West',
  'Western Cape'
];
